const sublinks = [
  {
    id: 1,
    page: 'Menu',
    classname: 'footer__menu',
    links: [
      { label: 'Home',  url: '/',   },
      { label: 'FAQ',  url: '/faq',  },
      
      
    ],
  },
  {
    id: 2,
    page: 'Services',
    classname: 'footer__services',
    links: [
      { label: 'Market',  url: '/market-place' ,   },
      { label: 'Partners',  url: '/partners' ,   },
      { label: 'SignUp',  url: '/',  },
      { label: 'Log In',  url: '/' ,   },
    ],
  },
  {
    id:3,
    page: 'Product Information',
    classname: 'footer__further',
    links: [
      { label: 'Terms and Condition',  url: '/' ,  },
      { label: 'Privacy Policy',  url: '/privacy_policy' ,   },
    ],
  },
];

export default sublinks;